import React from 'react'

const CompletedOrders = () => {
  return (
    <div>CompletedOrders</div>
  )
}

export default CompletedOrders